var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.58581,
    rx: 7.5,
    ry: 7.33209,
    fill: "#FFF1B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 2.22412C7.83655 2.22412 8.10938 2.49084 8.10938 2.81985V4.40847C8.10938 4.73749 7.83655 5.0042 7.5 5.0042C7.16345 5.0042 6.89062 4.73749 6.89062 4.40847V2.81985C6.89062 2.49084 7.16345 2.22412 7.5 2.22412Z",
    fill: "#FAAD14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1406 7.58572C10.1406 7.25671 10.4135 6.98999 10.75 6.98999H12.375C12.7115 6.98999 12.9844 7.25671 12.9844 7.58572C12.9844 7.91474 12.7115 8.18145 12.375 8.18145H10.75C10.4135 8.18145 10.1406 7.91474 10.1406 7.58572Z",
    fill: "#FAAD14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.36952 9.41338C9.6075 9.18073 9.99333 9.18073 10.2313 9.41338L11.379 10.5353C11.6169 10.768 11.6169 11.1452 11.379 11.3778C11.141 11.6105 10.7552 11.6105 10.5172 11.3778L9.36952 10.2559C9.13155 10.0232 9.13155 9.64603 9.36952 9.41338Z",
    fill: "#FAAD14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 10.1672C7.83655 10.1672 8.10938 10.434 8.10938 10.763V12.3516C8.10938 12.6806 7.83655 12.9473 7.5 12.9473C7.16345 12.9473 6.89062 12.6806 6.89062 12.3516V10.763C6.89062 10.434 7.16345 10.1672 7.5 10.1672Z",
    fill: "#FAAD14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63055 9.41338C5.86853 9.64603 5.86853 10.0232 5.63055 10.2559L4.4829 11.3778C4.24492 11.6105 3.85908 11.6105 3.62111 11.3778C3.38313 11.1452 3.38313 10.768 3.62111 10.5353L4.76877 9.41338C5.00674 9.18073 5.39258 9.18073 5.63055 9.41338Z",
    fill: "#FAAD14"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01562 7.58572C2.01562 7.25671 2.28845 6.98999 2.625 6.98999H4.25C4.58655 6.98999 4.85938 7.25671 4.85938 7.58572C4.85938 7.91474 4.58655 8.18145 4.25 8.18145H2.625C2.28845 8.18145 2.01562 7.91474 2.01562 7.58572Z",
    fill: "#FAAD14"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.62111 3.79363C3.85908 3.56098 4.24492 3.56098 4.4829 3.79363L5.63055 4.91559C5.86853 5.14824 5.86853 5.52543 5.63055 5.75808C5.39258 5.99073 5.00674 5.99073 4.76876 5.75808L3.62111 4.63612C3.38313 4.40347 3.38313 4.02627 3.62111 3.79363Z",
    fill: "#FAAD14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessing);
export default __webpack_public_path__ + "static/media/Processing.73ec2f99.svg";
export { ForwardRef as ReactComponent };